var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89645 10.7964L18.2851 4.14575C19.0088 3.833 19.7929 4.44159 19.6695 5.22023L17.5655 18.4962C17.4355 19.3162 16.4206 19.6299 15.8506 19.0262L12.3977 15.3686C11.7206 14.6514 11.6675 13.5475 12.2727 12.7686L14.7107 9.63084C14.8501 9.45146 14.63 9.21549 14.4414 9.34204L9.59406 12.5939C8.77148 13.1457 7.77341 13.3727 6.79309 13.2309L3.15003 12.704C2.15204 12.5597 1.97083 11.1964 2.89645 10.7964Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.d7a7b7b3c23fc7fd2e0eec46d68bb984.svg";
export { ForwardRef as ReactComponent };